import Page from 'components/layout/Page';
import Cta from 'components/marketingSite/successStories/layout/Cta';
import BlogPagination from 'components/marketingSite/successStories/layout/BlogPagination';
import { Heading1 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import {
  WP_REST_API_Post,
  WP_REST_API_Posts,
  WP_REST_API_Tags
} from 'wp-types';
import * as S from './SuccessStories.styled';
import PostCard from './cards/PostCard';
import { getPostThumb } from './utils/blogUtils';
import { useEffect } from 'react';

type SuccessStoriesProps = {
  posts?: WP_REST_API_Posts;
  featuredPost?: WP_REST_API_Post;
  totalPosts: number;
  totalPages: number;
  currentPage: number;
  tags?: WP_REST_API_Tags;
};

const SuccessStories: React.FC<SuccessStoriesProps> = ({
  posts = [],
  tags = [],
  featuredPost,
  totalPosts,
  totalPages,
  currentPage
}) => {
  const { t } = useI18n('success-stories');

  useEffect(() => {
    console.log({ posts, featuredPost });
  });

  return (
    <Page hasScrollTop>
      <S.Container>
        <S.Header>
          <Heading1>{t('page.title')}</Heading1>
          <div
            dangerouslySetInnerHTML={{
              __html: t('page.desc')
            }}
          ></div>
        </S.Header>
        {featuredPost ? (
          <S.FeaturedCardContainer>
            <PostCard
              isFeatured={true}
              post={featuredPost}
              key={featuredPost.slug}
              title={featuredPost.title.rendered}
              url={featuredPost.slug}
              thumb={getPostThumb(featuredPost)}
              date={featuredPost.date}
              excerpt={featuredPost.excerpt.rendered}
            />
          </S.FeaturedCardContainer>
        ) : null}

        <S.CardsContainer>
          {posts?.map((post) => {
            return (
              <PostCard
                post={post}
                key={post.slug}
                title={post.title.rendered}
                url={post.slug}
                thumb={getPostThumb(post)}
                date={post.date}
                excerpt={post.excerpt.rendered}
              />
            );
          })}
        </S.CardsContainer>
        {totalPages > 1 && (
          <BlogPagination
            totalPosts={totalPosts}
            totalPages={totalPages}
            currentPage={currentPage}
          />
        )}
        <Cta />
      </S.Container>
    </Page>
  );
};

export default SuccessStories;
